<div class="body-wrap">
    <div class="login login-v3">
        <div class="news-feed">
            <div class="news-image">

            </div>
        </div>
        <div class="right-content fullvh">
            <div class="login-header">
                <div class="brand text-center darby-logo-extra">
                    <img src="/assets/img/login-logo.png" alt="logo">
                </div>
            </div>
            <div class="login-content">
                <h3 class="loginC">Link expired</h3>
                <p class="mb-4">This password reset link has expired. Please request a new one.</p>
                <div class="login-buttons loginSubmit">
                    <button type="button" class="btn btn-peak btn-block btn-lg border-0" routerLink="/forgot-password">
                        Forgot Password
                    </button>
                </div>
                <div class="loginFooter">
                    <hr class="margTop20" />
                    <p class="text-center f-s-12">
                        &copy; {{footerText}}
                    </p>
                </div>
            </div>
        </div>
    </div>
</div>
